import React from "react"
import PropTypes from "prop-types"
import Nav from "../components/nav"
import Top from "../components/top"
import Main from "../components/main"
import Right from "../components/right"
import Footer from "../components/footer"
import "./layout.css"
import "react-toastify/dist/ReactToastify.css"
import { connect } from "react-redux"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faBars } from "@fortawesome/free-solid-svg-icons"
import {
  faQuestionCircle,
  faClipboard,
  faCopy,
  faTrashAlt,
} from "@fortawesome/free-regular-svg-icons"
import { ToastContainer, Slide } from "react-toastify"
import styled from "@emotion/styled"

library.add(faBars, faQuestionCircle, faClipboard, faCopy, faTrashAlt)

const StyledToastContainer = styled(ToastContainer)`
  &&&.Toastify__toast-container {
  }
  .Toastify__toast {
    background-color: #333;
    text-align: center;
    color: white;
    font-size: 22px;
  }
`

class Layout extends React.PureComponent {
  setupFacebook() {
    if (window.FB) {
      if (document.getElementById("facebook-jssdk")) {
        document.getElementById("facebook-jssdk").remove()
      }
      if (document.getElementById("fb-root")) {
        document.getElementById("fb-root").remove()
      }
      delete window.FB
    }
    window.fbAsyncInit = function() {
      window.FB.init({
        appId: "668843993240514",
        xfbml: true,
        version: "v3.3",
      })
    }
    const fb_el = document.createElement("script")
    fb_el.id = `facebook-jssdk`
    fb_el.src = `https://connect.facebook.net/${this.props.layoutContext.fbLanguageCode}/sdk.js`
    fb_el.async = true
    fb_el.defer = true
    document.body.insertBefore(fb_el, document.body.firstChild)
  }

  setupTwitter() {
    window.twttr = (function(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0],
        t = window.twttr || {}
      if (d.getElementById(id) && window.twttr.widgets) {
        window.twttr.widgets.load()
        return t
      }
      js = d.createElement(s)
      js.id = id
      js.src = "https://platform.twitter.com/widgets.js"
      fjs.parentNode.insertBefore(js, fjs)

      t._e = []
      t.ready = function(f) {
        t._e.push(f)
      }

      return t
    })(document, "script", "twitter-wjs")
  }

  componentDidMount() {
    this.setupFacebook()
    this.setupTwitter()
    this.props.initNav()
  }

  render() {
    const {
      content,
      breadcrumbs,
      global_strings,
      isDocked,
      pageTitle,
      pageSubtitle,
    } = this.props
    const {
      footerContext,
      navContext,
      topContext,
    } = this.props.layoutContext
    return (
      <>
        <StyledToastContainer
          position="bottom-center"
          autoClose={6000}
          hideProgressBar={true}
          transition={Slide}
        />
        <div className={`page_container ${isDocked ? "docked" : ""}`}>
          <Nav
            navContext={navContext}
            language={this.props.language}
            nav={this.props.nav}
            global_strings={this.props.global_strings}
            globalContext={this.props.globalContext}
            translatedLinks={this.props.translatedLinks}
            breadcrumbs={breadcrumbs}
          />
          <Main
            content={
              <>
                <Top
                  breadcrumbs={breadcrumbs}
                  pageTitle={pageTitle}
                  pageSubtitle={pageSubtitle}
                  topContext={topContext}
                  global_strings={global_strings}
                  language={this.props.language}
                  moreInfo={this.props.moreInfo || null}
                  moreInfoLinks={this.props.moreInfoLinks || null}
                  pageImage={this.props.pageImage || null}
                />
                {content}
                <div className="section divider_section"> </div>
                <Footer footerContext={footerContext} />
              </>
            }
          />
        </div>
        <Right />
      </>
    )
  }
}

Layout.propTypes = {
  content: PropTypes.node.isRequired,
  language: PropTypes.shape({
    code: PropTypes.string.isRequired,
    fb_code: PropTypes.string.isRequired,
  }),
}

export default connect(
  state => ({
    isDocked: state.isDocked,
  }),
  dispatch => {
    return {
      initNav: () => dispatch({ type: `INIT_NAV` }),
    }
  }
)(Layout)
